/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */
var FoldOut = new Class({
    foldOutOpen:false,
    foldOutQre:function(){
        return $('qre');
    },
    foldOutPanel:function(){
        if(this.panel){
            return this.panel;
        }else{
            return false;
        }
    },
    foldOutParent:function(){
        return $('conversation');
    },
    foldOutTitle:function(){
        return $('foldOutTitle');
    },
    foldOutHtml:function(){
        return $('foldOutHtml');
    },
    foldOutWrapper:function(){
        return $('foldOutWrapper');
    },
    foldOutContainer:function(){
        return $('botFoldOut');
    },
    foldOutCloseHandle:function(isNew){
        var foldOutClose = $$('.fold-out__close');
        if(foldOutClose && isNew){
            foldOutClose.addEvents({
                click:function(){
                    this.foldOutClose();
                }.bind(this)
            });
        }else{
            if(foldOutClose){
                foldOutClose.removeEvents();
            }
        }
    },
    foldOut:function(data, meta, callback){
        var type = meta.displayType;
        var title = meta.title;
        var isTitleLinkDisabled = meta.isTitleLinkDisabled;
        this.foldOutClosedCallback = callback;
        this.quriobot.foldOutClosedCallback = callback;
        if(this.foldOutOpen || type === "window"){
            return;
        }
        this.foldOutOpen = true;
        this.foldOutCloseHandle(this.foldOutOpen);

        if (this.foldOutOpen) {
            this.foldOutParent().fireEvent(
                'connMessage',
                {
                    action: 'foldOutOpen',
                    data: {
                        data: data,
                        title: title,
                        isTitleLinkDisabled: isTitleLinkDisabled,
                        type: type
                    }
                }
            );

            this.foldOutQre().addClass('foldOutMode');

            if(type !== 'iframe'){
                if(data) {
                    var el = this.foldOutHtml()
                    el.set('html', '');
                    window.postscribe(el, data)
                }

                if(title) {
                    this.foldOutTitle().set('html', title);
                }

                setTimeout(function(){
                    this.foldOutWrapper().addClass('fold-out_show_html');
                    this.foldOutContainer().addClass('fold-out_mode_display');
                }.bind(this),500);
            }

            setTimeout(function(){
                if(this.foldOutPanel() !== false){
                    this.foldOutParent().fireEvent('update');
                    this.foldOutPanel().removeClass('isLoading');
                }
            }.bind(this),1000);
        }
    },
    foldOutClose:function(){
        if(!this.foldOutOpen){
            return;
        }

        this.foldOutOpen = false;
        this.foldOutCloseHandle(this.foldOutOpen);

        this.foldOutContainer().removeClass('fold-out_mode_display');

        setTimeout(function(){
            this.foldOutQre().removeClass('foldOutMode');
            this.foldOutWrapper().removeClass('fold-out_show_html');
            this.foldOutContainer().removeClass('fold-out_type_no-header');
            var el = this.foldOutHtml()
            el.set('html', '');
            this.foldOutParent().fireEvent(
                'connMessage',
                {
                    action: 'foldOutClose',
                    data: {
                        type: this.data.meta.displayType
                    }
                }
            );
            if (this.foldOutClosedCallback) {
                this.foldOutClosedCallback()
            }
        }.bind(this),500);
    }
});
